import { createExperienceDictionary } from '@common/const/resource/experience';
import React from 'react';
import { useDeclination } from '@cp/shared/declination';

export const useExperienceDictionary = () => {
  const declination = useDeclination();

  return React.useMemo(() => {
    return createExperienceDictionary(declination);
  }, [declination]);
};
